import PropTypes from "prop-types";

import { alignItems } from "../../../../../../consts";
import { t } from "../../../../../../services";
import { dateUtil } from "../../../../../../utils";

import { FlexContainers, Paragraph2 } from "../../../../../../components";
import { SectionSummaryStyled } from "./styled";

const OverviewSectionSummary = ({ overviewSectionData }) => {
  const { campaignName, selectedCategory, selectedNotificationMessage, startDate, startTime } =
    overviewSectionData ?? {};

  return overviewSectionData ? (
    <SectionSummaryStyled
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      gap={8}
      width={"100%"}>
      <Paragraph2>{campaignName}</Paragraph2>
      <Paragraph2>{t(selectedCategory?.value)}</Paragraph2>
      <Paragraph2>{selectedNotificationMessage?.value}</Paragraph2>
      <Paragraph2>
        {startDate && startTime && dateUtil.formatDateAndTime(startDate, startTime)}
      </Paragraph2>
    </SectionSummaryStyled>
  ) : null;
};

OverviewSectionSummary.propTypes = {
  overviewSectionData: PropTypes.shape({
    campaignName: PropTypes.string.isRequired,
    selectedCategory: PropTypes.object.isRequired,
    selectedNotificationMessage: PropTypes.object.isRequired,
    startDate: PropTypes.object.isRequired,
    startTime: PropTypes.object.isRequired
  }).isRequired
};

export default OverviewSectionSummary;
